import React from "react";
import ExcelJS from "exceljs";

const DownloadXlsFile = (props) => {
  const handleDownload = async () => {
    const wb = new ExcelJS.Workbook();
    const ws = wb.addWorksheet("Books");

    ws.columns = [
      { header: "ISBN", key: "ISBN" },
      { header: "Author", key: "Author" },
      { header: "Title", key: "Title" },
      { header: "©Year", key: "Year" },
      { header: "Currency", key: "Currency" },
      { header: "List Price", key: "List Price" },
      { header: "Stream", key: "Stream" },
      { header: "Subject", key: "Subject" },
      { header: "Discount Category (Applicable for India Only)", key: "Discount Category" },
      { header: "Publication", key: "Publication" },
      { header: "Order Quantity", key: "Order Quantity" },
    ];

    props.data.forEach((item) => {
      ws.addRow({
        "ISBN": item.product_id,
        "Author": item.author,
        "Title": item.title,
        "Year": item.year,
        "Currency": item.currency,
        "List Price": item.list_price,
        "Stream": item.stream,
        "Subject": item.subject,
        "Discount Category": item.discount_category,
        "Publication": item.publication_details,
        "Order Quantity": item.box_size,
      });
    });

    const buffer = await wb.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "Books.xlsx";
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  };

  return (
    <React.Fragment>
      <button
        className="download-button es-button secondary es-js-tooltip"
        aria-label="Download file to view all book details."
        onClick={handleDownload}
      >
        <span>Download</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 98 128"
          height="24"
          width="19"
        >
          <path d="M77.38 56.18l-6.6-7.06L54 66.36V26H44v40.34L26.28 49.1l-7.3 7.08 29.2 29.32 29.2-29.32M88 74v20H10V74H0v30h98V74H88" />
        </svg>
      </button>
    </React.Fragment>
  );
};

export default DownloadXlsFile;
